import React from 'react';
import styles from './theme-color-config.less';
import { ColorSelectButton } from '@framework/workbench/drawer/components/color-select-button';
import i18n from 'i18next';
import { IThemeSelectItem } from '@src/slide/domain/ui-model/element-modeles/Interface/theme-model.interface';
import cloneDeep from 'lodash/cloneDeep';
import { TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';

export interface IThemeColorConfigProps {
    themeConfig: IThemeSelectItem,
    handleColorChange(props: IHandleColorChangeProps);
}

export interface IHandleColorChangeProps {
    key: string;
    color: string;
}


const THEME_COLOR_DESCRIPTION_MAP = {
    dk1: i18n.t('文字/背景 - 深色 1'),
    lt1: i18n.t('文字/背景 - 浅色 1'),
    dk2: i18n.t('文字/背景 - 深色 2'),
    lt2: i18n.t('文字/背景 - 浅色 2'),
    accent1: i18n.t('着色1'),
    accent2: i18n.t('着色2'),
    accent3: i18n.t('着色3'),
    accent4: i18n.t('着色4'),
    accent5: i18n.t('着色5'),
    accent6: i18n.t('着色6'),
    hlink: i18n.t('超链接'),
    folHlink: i18n.t('访问过的超链接'),
};

export class ThemeColorConfig extends React.Component<IThemeColorConfigProps, any> {
    render() {
        const { colorSchema } = this.props.themeConfig;
        const keyList = Object.keys(colorSchema);

        return <div className={styles['theme-color-config-container']}>
            {
                keyList.map((themeColorKey) => {
                    const themeColorItem = colorSchema[themeColorKey];
                    const { color } = themeColorItem;
                    return <div key={themeColorKey} className={styles['theme-color-item']}>
                        <div className={styles['theme-color-item-label']}>
                            { THEME_COLOR_DESCRIPTION_MAP[themeColorKey] }
                        </div>
                        <div className={styles['theme-color-item-button']}>
                            <ColorSelectButton
                                onColorChange={(color) => {
                                    this.props.handleColorChange({
                                        key: themeColorKey,
                                        color: color.getColorWithNoAlpha().replace('#', ''),
                                    });
                                }}
                                isStandardColorPicker={true}
                                value={new TDColor({ rgbaStr: color })}
                                paletteButtonsStyle={{
                                    width: 64,
                                    height: 24,
                                }}
                                colorBoxStyle={{
                                    width: 39,
                                    height: 22,
                                }}
                                iconWrapperStyle={{
                                    width: 23,
                                    height: 23,
                                    padding: 0,
                                }}
                                iconStyle={{
                                    width: 15,
                                    height: 15,
                                    position: 'absolute',
                                    left: 5,
                                    top: 4,
                                }}
                            />
                        </div>
                    </div>;
                })
            }
        </div>;
    }
}
